
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informacje-motoryzacja/wpis/[slug]",
      function () {
        return require("private-next-pages/informacje-motoryzacja/wpis/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informacje-motoryzacja/wpis/[slug]"])
      });
    }
  